const CONTENT_SERVICE = {
  HEADER_CODE_ID: 'primary',
  SECONDARY_TOP_NAV: 'swnz-secondary-nav-top-tier',
  SECONDARY_TOP_NAV_LOGGED_IN: 'swnz-login-nav-not-logged-in',
  QUICK_LINKS: 'swnz-quick-links',
}

export default CONTENT_SERVICE
